import { render, staticRenderFns } from "./TopTagList.vue?vue&type=template&id=17987294&scoped=true&"
import script from "./TopTagList.vue?vue&type=script&lang=js&"
export * from "./TopTagList.vue?vue&type=script&lang=js&"
import style0 from "./TopTagList.vue?vue&type=style&index=0&id=17987294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17987294",
  null
  
)

export default component.exports